import { render, staticRenderFns } from "./TmMultiSelect.vue?vue&type=template&id=1b606ad3&"
import script from "./TmMultiSelect.vue?vue&type=script&lang=js&"
export * from "./TmMultiSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports